// The contributor APIs still return deactivated contributors, flagged
// profile_linked: false. They have no profile to link to, so the expert
// listings leave them out. A missing flag (older app deploy) means active.
function activeContributors(data) {
  return (data || []).filter(function (contributor) {
    return contributor.profile_linked !== false;
  });
}

// CONTRIBUTOR HIGHLIGHT DATA POPULATE HOME PAGE
window.addEventListener("DOMContentLoaded", function () {
  current = window.location.pathname;

  if (current == "/") {
    $.get(
      window.apiEndpoint + "/api/contributors-list",
      function (data, textStatus, jqXHR) {
        data = activeContributors(data);
        if (!data.length) {
          return;
        }

        // Get the #home-expert-high container
        var highContainers = document.querySelectorAll(".home-expert-high");

        // Replace the placeholder card with the first item from the data
        highContainers.forEach((highContainer) => {
          highContainer.querySelector("h3").textContent = data[0].fullname;
          highContainer.querySelector("h3").classList.remove("placeholder");
          highContainer.querySelector(".cont-name").textContent = data[0].credentials;
          highContainer.querySelector(".cont-name").classList.remove("placeholder");
          highContainer.querySelector(".expert-h-headshot").src = data[0].headshot;
          highContainer.querySelector(".expert-h-headshot").classList.remove("placeholder");
          highContainer.querySelector("a").href = `/community/experts/${data[0].slug}`;
        });

        // Get the container for the cards
        let container = document.querySelector("#experts-home");

        // Get the placeholder card
        let card = document.querySelector(".ex-card");

        // Determine the number of items to display based on screen width
        let numItems = window.innerWidth < 992 ? 5 : 7;

        // For the next four items in the data, create new cards and add them to the page
        for (let i = 1; i < Math.min(data.length, numItems); i++) {
          let newCard = card.cloneNode(true);
          newCard.querySelector("h4").textContent = data[i].fullname;
          newCard.querySelector("h4").classList.remove("placeholder");
          newCard.querySelector(".cont-name").textContent = data[i].credentials;
          newCard.querySelector(".cont-name").classList.remove("placeholder");
          newCard.querySelector(".card-img").src = data[i].headshot;
          newCard.querySelector(".card-img").classList.remove("placeholder");
          newCard.querySelector(
            "a"
          ).href = `/community/experts/${data[i].slug}`;

          // Create a new div with the appropriate classes to wrap the new card
          let newDiv = document.createElement("div");
          newDiv.classList.add(
            "col-6",
            "col-md-3",
            "col-lg-4",
            "item",
            "pb-lg-3",
            "pb-xl-0"
          );
          newDiv.appendChild(newCard);

          container.appendChild(newDiv);
        }

        // Remove all placeholder cards from the DOM
        let placeholderCards = document.querySelectorAll(".placeholder-card");
        for (let i = 0; i < placeholderCards.length; i++) {
          container.removeChild(placeholderCards[i]);
        }
      }
    );
  }
});

// HOMEPAGE FOODGUIDE FEATURED DATA POPULATE
window.addEventListener("DOMContentLoaded", function () {
  current = window.location.pathname;

  if (current == "/") {
    $.get(
      window.apiEndpoint + "/api/foodguides",
      function (data, textStatus, jqXHR) {
        let ids = [
          "feat-articles-guide",
          "feat-recipes-guide",
          "feat-products-guide",
        ];

        for (let i = 0; i < Math.min(data.length, 3); i++) {
          let newCard = document.createElement("div");
          newCard.innerHTML = `
          <div class="guide-card">
            <div class="card g-card mb-3 shadow-sm">
            <div class="position-absolute top-0 end-0 p-3">
              <span class="badge fg-date rounded-pill py-2 py-md-1">
              ${data[i].product_count} Products
              </span>
            </div>
              <div class="row g-0 hp-feat-sub-card">
                <div class="feat-article-hero-md-6">
                  <a href="/community/experts/foodguide/${data[i].slug}">
                  <img
                    class="img-cover card-img d-md-block"
                    src="${data[i].hero_image}"
                    height="169px"
                    width="300px"
                  >
                    </a>
                </div>
                <div>
                  <div class="card-body pt-1">
                    <div class="d-flex align-items-center pt-2 pt-md-1">
                    <div class="title-wrapper">
                      <h3 class="mb-0 lh-2 card-title clamp-lines-3" style="color:#fff;">${
                        data[i].title
                      }</h3>
                      </div>
                      </div>
                    <div class="mt-1 mt-md-0">
                      ${data[i].friendlinesses
                        .map(
                          (f) =>
                            `<span class="badge fg-badge rounded-pill py-2 py-md-1">${f}</span>`
                        )
                        .join(" ")}
                    </div>
                    <div class="row mt-2">
                      <div class="col-7 pe-0 pt-1">
                        <div class="d-flex align-items-start align-items-center">
                        <img
                        class="avatar rounded-circle ms-0 me-2"
                        src="${data[i].contributor_headshot}"
                        height=""
                        width=""
                      >
                      <div>
                        <p class="cont-name fst-italic mt-1 mb-0 clamp-lines-1">
                          ${data[i].contributor_name}</p>
                        <p class="cont-name fst-italic mb-0 clamp-lines-1">
                          ${data[i].contributor_creds}
                        </p>
                      </div>
                        </div>
                      </div>
                      <div class="col-5 text-end ps-1 pt-2 ps-lg-1 pe-xl-1 pe-xxl-2">
                        <a href="/community/experts/foodguide/${
                          data[i].slug
                        }" class="btn card-but align-items-end my-0" style="background-color:#fff;color:#0a8484;">View<span class="card-but-obj"> Guide</span></a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        `;

          let parentElement = document.getElementById(ids[i]);
          let oldCard = parentElement.querySelector(".guide-card");
          parentElement.replaceChild(newCard, oldCard);
        }

        // The guide hero cards were swapped in above (after the initial
        // Masonry layout). Re-init/relayout once their images have loaded so
        // Masonry positions the homepage grids against the final heights.
        if (typeof Masonry !== "undefined") {
          initMasonryGrids();
        }
      }
    );
  }
});

// FOODGUIDES SIDEBAR DATA POPULATE
window.addEventListener("DOMContentLoaded", function () {
  let current = window.location.pathname;
  let pages = ["/blogs/recipes", "/blogs/from-the-experts", "/collections/all"];

  if (pages.includes(current)) {
    $.get(
      window.apiEndpoint + "/api/foodguides",
      function (data, textStatus, jqXHR) {
        let sidebarElements = document.querySelectorAll(".sidebar-guides");

        sidebarElements.forEach(function (sidebarElement) {
          // Remove existing card
          let oldCard = sidebarElement.querySelector(".content-card-sm");
          if (oldCard) oldCard.remove();
        });

        // Add new cards
        data.forEach(function (item) {
          let newCard = document.createElement("div");
          newCard.innerHTML = `
          <div class="content-card-sm pe-3 pe-lg-0 pb-lg-3">
            <div class="card g-card shadow-sm mb-2 position-relative">
              <div class="position-absolute top-0 end-0 p-3">
                <span class="badge fg-date rounded-pill py-2 py-md-1">
                  ${item.product_count} Products
                </span>
              </div>
              <div class="row g-0 hp-feat-sub-card">
                <div class="feat-article-hero-md-6">
                  <a href="/community/experts/foodguide/${item.slug}">
                    <img
                      class="img-cover card-img d-md-block"
                      src="${item.hero_image}"
                      height="169px"
                      width="300px"
                    >
                  </a>
                </div>
                <div>
                  <div class="card-body pt-1">
                    <div class="d-flex align-items-center">
                    <div class="title-wrapper">
                      <h3 class="mb-0 lh-2 card-title clamp-lines-2">${item.title}</h3>
                    </div>
                    </div>
                    <div class="row">
                      <div class="col-6 pe-0">
                        <div class="d-flex align-items-start align-items-center">
                        </div>
                      </div>
                      <div class="col-6 text-end pt-1">
                        <a href="/community/experts/foodguide/${item.slug}" class="btn card-but align-items-end my-0">View<span class="card-but-obj"> Guide</span></a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        `;

          sidebarElements.forEach(function (sidebarElement) {
            let viewAllLink = sidebarElement.querySelector(".ps-1.pe-3");
            sidebarElement.insertBefore(newCard.cloneNode(true), viewAllLink);
          });
        });
      }
    );
  }
});

// CONTRIBUTORS DATA POPULATE FOR MISSION PAGE
window.addEventListener("DOMContentLoaded", function () {
  current = window.location.pathname;

  if (current == "/pages/our-mission") {
    $.get(
      window.apiEndpoint + "/api/contributors-list",
      function (data, textStatus, jqXHR) {
        data = activeContributors(data);
        if (!data.length) {
          return;
        }

        // Get the #expert-high-lg container
        let highContainer = document.querySelector("#expert-high-lg");

        // Replace the placeholder card with the first item from the data
        highContainer.querySelector("h3").textContent = data[0].fullname;
        highContainer.querySelector("h3").classList.remove("placeholder");
        highContainer.querySelector(".cont-name").textContent =
          data[0].credentials;
        highContainer
          .querySelector(".cont-name")
          .classList.remove("placeholder");
        highContainer.querySelector(".rounded-4").src = data[0].headshot;
        highContainer
          .querySelector(".rounded-4")
          .classList.remove("placeholder");
        highContainer.querySelector(
          "a"
        ).href = `/community/experts/${data[0].slug}`;

        // Get the container for the cards
        let container = document.querySelector("#experts");

        // Get the placeholder card
        let card = document.querySelector(".expert");

        // Remove the placeholder card from the DOM
        container.removeChild(card);

        // For the rest of the items in the data, create new cards and add them to the page
        for (let i = 1; i < data.length; i++) {
          let newCard = card.cloneNode(true);
          newCard.querySelector("h4").textContent = data[i].fullname;
          newCard.querySelector("h4").classList.remove("placeholder");
          newCard.querySelector(".cont-name").textContent = data[i].credentials;
          newCard.querySelector(".cont-name").classList.remove("placeholder");
          newCard.querySelector(".card-img").src = data[i].headshot;
          newCard.querySelector(".card-img").classList.remove("placeholder");
          newCard.querySelector(
            "a"
          ).href = `/community/experts/${data[i].slug}`;
          container.appendChild(newCard);
        }

        // Initialize Masonry after all images have loaded
        imagesLoaded(container, function () {
          let msnry = new Masonry(container, {
            itemSelector: ".expert",
            percentPosition: true,
          });
          msnry.layout();
        });
      }
    );
  }
});

// PRODUCT META DATA REPLACE
window.addEventListener("DOMContentLoaded", function () {
  // GET SHOPIFY IDS FOR DATA CALL --
  var shopifyproductid = $("#shopifyproductid").text();

  // LOOK FOR PRODUCT META
  if (shopifyproductid.length > 0) {
    $.get(
      window.apiEndpoint + "/api/product",
      { shopifyproductid: shopifyproductid },
      function (data, textStatus, jqXHR) {
        // $.get('https://stagingapp.foodguides.com/api/product', {shopifyproductid: shopifyproductid}, function (data, textStatus, jqXHR) {
        // FOODGUIDES PRODUCT META DATA IN-HAND FROM FG ADMIN --
        // $('.diet-rating-area p').text(data.diets);
        // $('.diet-review-area p').text(data.assessment);
        // console.log(data);
      }
    );
  }
});

// MASONRY GRID INIT
// Initialize Masonry ONLY after each grid's images have loaded so the cards
// have their final heights before they are absolutely positioned. We used to
// rely on Masonry's `data-masonry` auto-init, which runs on DOMContentLoaded
// (before images load) — on a cold/uncached load that laid the grid out
// against zero-height images and the cards rendered on top of each other. It
// only "fixed itself" on refresh because cached images report their height
// instantly. Driving the init from imagesLoaded makes first paint reliable.
function initMasonryGrids() {
  // #experts (about/mission page) is AJAX-populated and initialized separately
  // with its own `.expert` itemSelector, so it is excluded here.
  $(".masonry-items").not("#experts").each(function () {
    var $grid = $(this);
    $grid.imagesLoaded(function () {
      // Creates the instance (or returns the existing one) and forces a
      // layout pass against the now fully-loaded image heights.
      $grid.masonry({
        itemSelector: ".item",
        percentPosition: true,
      });
      $grid.masonry("layout");
    });
  });
}

// Re-run layout on already-initialized grids (e.g. after responsive show/hide).
function relayoutMasonry() {
  $(".masonry-items").not("#experts").each(function () {
    if ($(this).data("masonry")) {
      $(this).masonry("layout");
    }
  });
}

if (typeof Masonry !== "undefined") {
  initMasonryGrids();
} else {
  // Fallback in case the Masonry library hasn't executed yet.
  window.addEventListener("load", initMasonryGrids);
}

// HIDE/SHOW ARTICLES ON HOMEPAGE BASED ON WINDOW WIDTH
const adjustArticles = function () {
  const maxWidth = 1199;
  const $articles = $(".featured-articles-section .hm-art-cnt");
  const maxArticles = $(window).width() > maxWidth ? 7 : 5;
  $articles.show().slice(maxArticles).hide();

  // Recalculate Masonry layout
  relayoutMasonry();
};

// Adjust articles immediately when the script is run
adjustArticles();

$(document).ready(function () {
  // Adjust articles on window resize
  $(window).resize(adjustArticles);
});

// HIDE/SHOW RECIPES ON HOMEPAGE BASED ON WINDOW WIDTH
const adjustRecipes = function () {
  const maxWidth = 1199;
  const $recipes = $(".featured-recipes-section .hm-art-cnt");
  const maxRecipes = $(window).width() > maxWidth ? 7 : 5;
  $recipes.show().slice(maxRecipes).hide();

  // Recalculate Masonry layout
  relayoutMasonry();
};

// Adjust recipes immediately when the script is run
adjustRecipes();

$(document).ready(function () {
  // Adjust recipes on window resize
  $(window).resize(adjustRecipes);
});

// HIDE/SHOW PRODUCTS ON HOMEPAGE BASED ON WINDOW WIDTH
const adjustProducts = function () {
  const $products = $(".featured-products-section .hm-pro-cnt");
  let maxProducts;

  if ($(window).width() > 1199) {
    maxProducts = 10; // Number of products for screens wider than 1200px
  } else if ($(window).width() > 991) {
    maxProducts = 7; // Number of products for screens between 992px and 1199px
  } else {
    maxProducts = 6; // Number of products for screens 991px and below
  }

  $products.show().slice(maxProducts).hide();

  // Recalculate Masonry layout
  relayoutMasonry();
};

// Adjust products immediately when the script is run
adjustProducts();

$(document).ready(function () {
  // Adjust products on window resize
  $(window).resize(adjustProducts);
});

// FILTER CONTENT MODAL
// document.addEventListener("DOMContentLoaded", (event) => {
//   var filterLink = document.getElementById("filter-link");
//   var filterModal = new bootstrap.Modal(
//     document.getElementById("filter-modal"),
//     {
//       keyboard: false,
//     }
//   );

//   filterLink.addEventListener("click", function (event) {
//     event.preventDefault();
//     filterModal.show();
//   });
// });

// CLOSES THE MOBILE MENU WHEN 'CONNECT' IS CLICKED
$(document).ready(function () {
  $('a[href="#connect-footer"]').click(function () {
    $(".collapse").collapse("hide");
  });
});

// SHARE PANEL
jQuery(document).ready(function ($) {
  // Function to update URLs dynamically
  function updateShareLinks() {
    var currentUrl = window.location.href; // Gets the current URL from the browser
    var pageTitle = document.title; // Gets the current page title

    // Update the Facebook share link
    $("#facebookShare").attr(
      "href",
      "https://www.facebook.com/sharer/sharer.php?u=" +
        encodeURIComponent(currentUrl)
    );

    // Update the Twitter share link
    $("#twitterShare").attr(
      "href",
      "https://twitter.com/intent/tweet?text=" +
        encodeURIComponent(pageTitle) +
        "&url=" +
        encodeURIComponent(currentUrl)
    );

    // Update the Reddit share link
    $("#redditShare").attr(
      "href",
      "https://www.reddit.com/submit?url=" +
        encodeURIComponent(currentUrl) +
        "&title=" +
        encodeURIComponent(pageTitle)
    );

    // Update the SMS share link
    $("#smsShare").attr(
      "href",
      "sms:?&body=Check out this page " + encodeURIComponent(currentUrl)
    );

    // Update the Email share link
    $("#emailShare").attr(
      "href",
      "mailto:?subject=" +
        encodeURIComponent(pageTitle) +
        "&body=Check out this page: " +
        encodeURIComponent(currentUrl)
    );
  }

  // When the share panel is triggered to open
  $("#shareFab").click(function () {
    updateShareLinks(); // Update links right before the panel slides in
    if (window.innerWidth > 1026) {
      $("#shareOptionsPanel").animate({ right: "0" }, 300);
    } else {
      $("#shareOptionsPanel").animate({ bottom: "0" }, 300);
    }
  });

  // X button to close
  $(".close").click(function () {
    if (window.innerWidth > 1026) {
      $("#shareOptionsPanel").animate({ right: "-170px" }, 300);
    } else {
      $("#shareOptionsPanel").animate({ bottom: "-100%" }, 300);
    }
  });

  // Clicking outside the panel hides it
  $(document).mouseup(function (e) {
    var container = $("#shareOptionsPanel");
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      if (window.innerWidth > 1026) {
        container.animate({ right: "-170px" }, 300);
      } else {
        container.animate({ bottom: "-100%" }, 300);
      }
    }
  });

  // Copy to Clipboard functionality for the copy button
  $("#copyButton").click(function () {
    navigator.clipboard
      .writeText(window.location.href)
      .then(function () {
        alert("URL copied to clipboard!");
      })
      .catch(function (error) {
        alert("Error copying URL: " + error);
      });
  });
});

// SEARCH RESULTS: PRODUCT SIDEBAR (ASYNC VIA /search/suggest.json)
window.addEventListener("DOMContentLoaded", function () {
  var sidebar = document.getElementById("fg-search-products-sidebar");
  var q = sidebar && sidebar.dataset.q;

  if (!sidebar || !q) {
    return;
  }

  var escapeHtml = function (value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  };

  fetch(
    "/search/suggest.json?q=" +
      encodeURIComponent(q) +
      "&resources[type]=product&resources[limit]=12&resources[options][unavailable_products]=last",
    { headers: { Accept: "application/json" } }
  )
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      var products =
        (data.resources && data.resources.results && data.resources.results.products) || [];

      if (!products.length) {
        sidebar.innerHTML = '<p class="text-muted small">No matching products.</p>';
        return;
      }

      sidebar.innerHTML = products
        .map(function (product) {
          var image = product.image
            ? '<img src="' +
              escapeHtml(product.image) +
              '" class="product-listing-image p-1" width="100%" alt="' +
              escapeHtml(product.title) +
              '">'
            : "";

          return (
            '<div id="product-card">' +
            '<a href="' +
            escapeHtml(product.url) +
            '" style="text-decoration:none;">' +
            '<div class="card prod-card mb-3 hm-pro-cnt shadow-sm">' +
            '<div class="card-body py-md-2">' +
            '<div class="row pt-md-1 pt-lg-1">' +
            '<div class="col-5 ps-0 pe-2 pt-md-2">' +
            image +
            "</div>" +
            '<div class="col-7 text-start ps-0 d-flex flex-column justify-content-between" style="height:144px">' +
            '<h3 class="d-flex align-items-center prod-title clamp-lines-2 pt-1 pt-md-2 pt-lg-1 pb-0 mb-1 mb-md-0 mb-lg-1">' +
            escapeHtml(product.title) +
            "</h3>" +
            '<p class="exsm-link ps-1 pt-2 mb-1">View Product<span class="border-0 px-0"><i class="bi bi-arrow-right-short icon-sm prim-color nudge-left" style="font-size:20px"></i></span></p>' +
            "</div>" +
            "</div>" +
            "</div>" +
            "</div>" +
            "</a>" +
            "</div>"
          );
        })
        .join("");
    })
    .catch(function (error) {
      console.warn("Search product sidebar fetch failed:", error);
    });
});

// HUBS CONTENTS TOGGLE
$(document).ready(function () {
  // Initially open
  $(".contents-list").show();
  $(".toggle-arrow").addClass("open");

  // Toggle contents list on label click
  $(".contents-label").click(function () {
    $(".contents-list").toggle();
    $(".toggle-arrow").toggleClass("open");
  });

  // Collapse contents list when the label reaches the top
  $(window).scroll(function () {
    var stickToc = $(".stick-toc");
  
    // Check if the .stick-toc element exists
    if (stickToc.length > 0) {
      var tocOffset = stickToc.offset().top - 30; // Adjust for sticky offset
      var scrollPosition = $(window).scrollTop();
  
      if (scrollPosition >= tocOffset) {
        if ($(".contents-list").is(":visible")) {
          $(".contents-list").hide();
          $(".toggle-arrow").removeClass("open");
        }
      }
    }
  });

  // Ensure the list collapses if the user clicks a link
  $(".contents-list a").click(function () {
    $(".contents-list").hide();
    $(".toggle-arrow").removeClass("open");
  });
});
